module.exports = __webpack_public_path__ + "img/it.88aa4ffc.svg";